/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasResponse } from '../../openapi/models/OasResponse';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { AddResponseDefinitionCommand } from './AddResponseDefinitionCommand';

/**
 * OAI version 2.0 impl.
 * @author eric.wittmann@gmail.com
 * @extends AddResponseDefinitionCommand
 * @class
 */
export class AddResponseDefinitionCommand_20 extends AddResponseDefinitionCommand {
    public _nullDefinitions : boolean;

    public constructor(definitionName? : any, from? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super(definitionName, from);
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else if(((typeof definitionName === 'string') || definitionName === null) && from === undefined) {
            let __args = arguments;
            super(definitionName);
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else if(definitionName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#defExists(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {boolean}
     */
    defExists(document : OasDocument) : boolean {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.responses)) {
            return false;
        }
        return !this.isNullOrUndefined(doc20.responses.getResponse(this._newDefinitionName));
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#prepareDocumentForDef(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    prepareDocumentForDef(document : OasDocument) {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.responses)) {
            doc20.responses = doc20.createResponseDefinitions();
            this._nullDefinitions = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#createResponseDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {OasResponse}
     */
    createResponseDefinition(document : OasDocument) : OasResponse {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definition : Oas20ResponseDefinition = doc20.responses.createResponse(this._newDefinitionName);
        Library.readNode(this._newDefinitionObj, definition);
        return definition;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#addDefinition(io.apicurio.datamodels.openapi.models.OasDocument, io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasDocument} document
     * @param {OasResponse} definition
     */
    addDefinition(document : OasDocument, definition : OasResponse) {
        let doc20 : Oas20Document = <Oas20Document>document;
        let def20 : Oas20ResponseDefinition = <Oas20ResponseDefinition>definition;
        doc20.responses.addResponse(this._newDefinitionName, def20);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#removeDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    removeDefinition(document : OasDocument) {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this._nullDefinitions) {
            doc20.responses = null;
        } else {
            doc20.responses.removeResponse(this._newDefinitionName);
        }
    }
}
AddResponseDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand_20";
AddResponseDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




